module.exports = __webpack_public_path__ + "img/50.e78da96b.svg";